import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import SingleArrowDown from '@r1-frontend/ui-react/components/svg/arrows/SingleArrowDown';
import SingleArrowUp from '@r1-frontend/ui-react/components/svg/arrows/SingleArrowUp';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import { hex2rgb } from '@r1-frontend/shared/helpers/hex2rgb';

export const Topic = styled.div`
    padding-bottom: 16px;
    width: 100%;
`;

export const TopicListWrap = styled.div`
    height: max-content;
    width: 480px;
    min-width: 480px;
    background-color: ${COLORS.BgSubstrate};
    border-radius: ${BorderRadius.OuterBlockRadius};
    display: flex;
    flex-direction: column;
    padding: 24px 0 68px 0;
    
    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 488px;        
        min-width: 488px;        
    }
    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 376px;
        min-width: 376px;
    }
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        min-width: 343px;
        padding: 16px 0 24px 0;
    }
`;

export const Articles = styled.div`
    padding-bottom: 24px;
    gap: 12px;
    
    @media (max-width: ${wideBreakpoints.tablet}) {
        padding-bottom: 16px;
    }
`;

export const SubTitle = styled.button<{ isActive?: boolean }>`  
    ${props => props.isActive ? FONTS.H4 : FONTS.L}; 
    color: ${COLORS.Link};
    width: 100%;
    border: none;
    background-color: transparent;
    cursor: pointer;
    text-align: start;
    word-break: break-word;
    padding: 0 24px 0 ${props => props.isActive ?  '73px' : '75px'};
    ${props => props.isActive && `border-left: 2px solid ${COLORS.Link}`};
    
    @media (max-width: ${wideBreakpoints.tablet}) {
        ${props => props.isActive ? FONTS.H5 : FONTS.S}; 
    }
    @media (max-width: ${wideBreakpoints.mobile}) {
         width: 100%;
         padding: 0 24px 0 ${props => props.isActive ?  '35px' : '38px'};
    }
;
`;

export const Title = styled.div<{ isActive?: boolean }>`
    background-color: ${props => props.isActive ? `rgba(${hex2rgb(COLORS.ButtonSecondary)}, .5)` : 'transparent'};
    border-radius: ${BorderRadius.OuterBlockRadius};
    padding: ${props => props.isActive ? '8px 22px 8px 8px' : '0 22px 0 8px'};
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0 24px 0 24px ;
    cursor: pointer;
    word-break: break-word;
    flex-wrap: nowrap;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        margin: 0 16px 0 16px ;
    }
`;

export const TitleText = styled(H4)`
    color: ${COLORS.TextPrimary};
    margin-right: auto;
    padding: 0 16px;
    width: auto;
`;

export const Img = styled.img`
    border-radius: 50%;
    background-color: ${COLORS.Locked};
    height: 45px;
    width: 45px;
`;

export const MobileButton = styled(Button)`
    margin-bottom: 24px;
    width: 100%;
    justify-content: center;
    display: none;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        display: flex;
    }
`;

export const Container = styled.div`
    @media (max-width: ${wideBreakpoints.mobile}) {
        display: block;
        width: 100%;
    }
`;

export const ButtonBack = styled(Button)`
    margin-bottom: 32px;
    padding-left: 0;
`;

export const ArrowUp = styled(SingleArrowUp)<{isOpen : boolean}>`
    min-width: 24px;
    transform: rotate(${({ isOpen }) => isOpen ? '0' : '180deg'});
    transition: transform 150ms ease;
`;

export const ArrowDown = styled(SingleArrowDown)`
    min-width: 24px;
`;
